export default "__VITE_ASSET__35f672d8__"